import { render, staticRenderFns } from "./PictureNav.vue?vue&type=template&id=b07b0eba&scoped=true&"
import script from "./PictureNav.vue?vue&type=script&lang=js&"
export * from "./PictureNav.vue?vue&type=script&lang=js&"
import style0 from "./PictureNav.vue?vue&type=style&index=0&id=b07b0eba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b0eba",
  null
  
)

export default component.exports